export default function ({ $auth, $axios }) {
  if ($auth?.loggedIn) {
    $axios.setToken($auth.getToken('local'))
  } else {
    // $axios.setToken('cUN5-MNgeC6NY-nG_edUpAijsPfzT32H', 'Bearer')
    $axios.setToken('cUN5-MNgeC6NY-nG_edUpAijsPfzT32H', 'Bearer')
  }
}
